import store from "../vuex/store.js";
import api from "../request/apis.js";
import { Dialog } from "vant";
export const commonObj = {
  //检查角色权限
  checkRole(roleArr) {
    let ret = false;
    let roleIdList = store.state.stateObject.userInfo.roleList;
    roleIdList.forEach(element => {
      if (roleArr.indexOf(element.roleId) > -1) {
        ret = true;
      }
    });
    return ret;
  },

  DateDiff(sDate1, sDate2) {
    //sDate1和sDate2是2002-12-18格式
    var aDate, oDate1, oDate2, iDays;
    aDate = sDate1.split("-");
    oDate1 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]); //转换为12-18-2002格式
    aDate = sDate2.split("-");
    oDate2 = new Date(aDate[1] + "-" + aDate[2] + "-" + aDate[0]);
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
    return iDays;
  },
  processDateRangeByWeek1(startDateStr, endDateStr) {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    // 确保起始日期是周一
    startDate.setDate(startDate.getDate() - (startDate.getDay() || 7) + 1);

    const weeks = [];
    let currentWeekStart = new Date(startDate);

    // 循环直到超过结束日期
    while (currentWeekStart <= endDate) {
      const weekDays = [];

      // 填充当前周的每一天（从周一到周日）
      for (let dayOfWeek = 0; dayOfWeek < 7; dayOfWeek++) {
        const day = new Date(currentWeekStart);
        day.setDate(currentWeekStart.getDate() + dayOfWeek);

        // 检查这一天是否在时间段内
        if (day <= endDate) {
          weekDays.push({
            date: `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(
              2,
              "0"
            )}-${String(day.getDate()).padStart(2, "0")}`,
            dayOfWeek: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday"
            ][dayOfWeek]
          });
        }
        // 如果这一天超过了结束日期，则跳出循环（实际上在这个场景下不需要，因为while循环会处理）
      }

      // 将当前周的数据添加到结果数组中
      weeks.push({
        weekStart: `${currentWeekStart.getFullYear()}-${String(
          currentWeekStart.getMonth() + 1
        ).padStart(2, "0")}-${String(currentWeekStart.getDate()).padStart(
          2,
          "0"
        )}`,
        days: weekDays,
        currentMonth: `${currentWeekStart.getMonth() + 1}`
      });

      // 移动到下一周的开始
      currentWeekStart.setDate(currentWeekStart.getDate() + 7);
    }

    return weeks;
  },

  // 将单位为秒的时间转成时分秒格式
  formatSecondsToHMS(seconds) {
    // 处理输入不是有效数字的情况
    if (typeof seconds !== "number" || isNaN(seconds)) {
      return "0秒";
    }
    // 处理负数情况
    seconds = Math.abs(Math.round(seconds));

    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;

    const parts = [];
    if (hours > 0) {
      parts.push(`${hours}时`);
    }
    if (minutes > 0) {
      parts.push(`${minutes}分`);
    }
    if (seconds > 0 || (hours === 0 && minutes === 0)) {
      parts.push(`${seconds}秒`);
    }

    return parts.join("");
  },
  formatDate(date) {
    if (date == null) {
      return "暂无";
    }
    // ${date.getFullYear()}/
    return `${date.getMonth() + 1}/${date.getDate()}`;
  },
  formatDate2(date) {
    if (date == null) {
      return "暂无";
    }

    return ` ${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  },
  formatDateToYearMonth(dateStr) {
    if (dateStr == null || dateStr == "") {
      return "";
    }
    var date = new Date(dateStr); //转换
    //重组
    var datetime =
      date.getFullYear() +
      "-" + //年
      (date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1));
    return datetime;
  },
  //时分秒转换日期
  formatDateToDay(dateStr) {
    if (dateStr == null || dateStr == "") {
      return "";
    }
    var date = new Date(dateStr); //转换
    //重组
    var datetime =
      date.getFullYear() +
      "-" + //年
      (date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "-" + //月
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()); //日
    return datetime;
  },
  //时分转换日期
  formatDateTominute(dateStr) {
    if (dateStr == null || dateStr == "") {
      return "-";
    }
    var date = new Date(dateStr); //转换
    //重组
    var datetime =
      date.getFullYear() +
      "-" + //年
      (date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "-" + //月
      //(date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + " " + date.getHours() + ":" + date.getMinutes(); //日
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      " " +
      (date.getHours() > 9 ? date.getHours() : "0" + date.getHours()) +
      ":" +
      (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()); //日
    return datetime;
  },
  //时分秒转换日期
  formatDateToSeconds(dateStr) {
    if (dateStr == null || dateStr == "") {
      return "-";
    }
    var date = new Date(dateStr); //转换
    //重组
    var datetime =
      date.getFullYear() +
      "-" + //年
      (date.getMonth() + 1 > 9
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)) +
      "-" + //月
      (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
      " " +
      (date.getHours() > 9 ? date.getHours() : "0" + date.getHours()) +
      ":" +
      (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()) +
      ":" +
      (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds()); //日
    return datetime;
  },
  addScrollTop(dom) {
    let pageMap = store.state.stateObject.pageMap;
    let key = this.getQueryVariable("stack-key");
    let scrollTop = document.getElementsByClassName("myScrollTop")[0].scrollTop;
    if (pageMap == null) {
      pageMap = new Map();
    }
    if (dom) {
      scrollTop = dom.scrollTop;
    }
    console.log(JSON.stringify(pageMap));
    pageMap[key] = scrollTop;
    store.commit("stateFn", pageMap);
  },
  removeScrollTop(dom) {
    let pageMap = store.state.stateObject.pageMap;
    let key = this.getQueryVariable("stack-key");
    if (pageMap == null) {
      return;
    }
    console.log("removeScrollTop==" + pageMap[key]);
    if (!pageMap[key]) {
      return;
    }
    if (dom) {
      dom.scrollTop = pageMap[key];
    } else {
      document.getElementsByClassName("myScrollTop")[0].scrollTop =
        pageMap[key];
    }

    delete pageMap[key];
    store.commit("stateFn", pageMap);
  },
  getUserInfo() {
    return store.state.stateObject.userInfo;
  },
  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },
  isServiceCallSuccess(code) {
    if (code == "000000") {
      return true;
    } else {
      return false;
    }
  },
  showLoadingex(msg) {
    var loadingcontent = document.getElementById("loadingbg");
    if (loadingcontent) {
      loadingcontent.style.display = "";
      if (msg) {
        document.getElementById("loadingmsg").innerHTML = msg;
      }
    } else {
      loadingcontent = document.createElement("DIV");
      loadingcontent.id = "loadingbg";
      loadingcontent.classList = "loadingbar";
      //  loadingcontent.innerHTML = "<div class='loaddingLess'><img class='loadingimg' src='data:image/gif;base64,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' /><div id='loadingmsg' class='loadingmsg'>" + (msg ? msg : '') + "</div></div>";
      loadingcontent.innerHTML =
        "<div class='loaddingLess'><img class='loadingimg' src='data:image/gif;base64,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' /><div id='loadingmsg' class='loadingmsg'>" +
        (msg ? msg : "") +
        "</div></div>";
      document.body.appendChild(loadingcontent);
    }
  },
  showLoadingex2(msg) {
    var loadingcontent = document.getElementById("loadingbg");
    if (loadingcontent) {
      loadingcontent.style.display = "";
      if (msg) {
        document.getElementById("loadingmsg").innerHTML = msg;
      }
    } else {
      loadingcontent = document.createElement("DIV");
      loadingcontent.id = "loadingbg";
      loadingcontent.classList = "loadingbar";
      loadingcontent.innerHTML =
        "<div class='loaddingLess'><img class='loadingimg' src='data:image/gif;base64,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' /><div id='loadingmsg' class='loadingmsg'>" +
        (msg ? msg : "") +
        "</div></div>";
      document.body.appendChild(loadingcontent);
    }
  },
  showLoading(msg) {
    var loadingcontent = document.getElementById("loadingbg");
    if (loadingcontent) {
      loadingcontent.style.display = "";
      if (msg) {
        document.getElementById("loadingmsg").innerHTML = msg;
      }
    } else {
      loadingcontent = document.createElement("DIV");
      loadingcontent.id = "loadingbg";
      loadingcontent.classList = "loadingbar";
      loadingcontent.innerHTML =
        "<div class='loaddingLess'><img class='loadingimg img01' src=" +
        "'data:image/png;base64,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" +
        "' /><div id='loadingmsg' class='loadingmsg'>" +
        (msg ? msg : "") +
        "</div></div>";
      document.body.appendChild(loadingcontent);
    }
  },

  hidLoading() {
    var loadingBar = document.getElementById("loadingbg");
    if (loadingBar) {
      loadingBar.style.display = "none";
    }
  },
  //获取url参数
  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },
  getCurrentProjectId() {
    let thisProjectInfo = JSON.parse(localStorage.getItem("thisProjectInfo"));
    return thisProjectInfo ? thisProjectInfo.projectId : "";
  },
  //获取当前场次
  getCurrentHisId() {
    let ret = "";
    let thisProjectInfo = localStorage.getItem("thisProjectInfo")
      ? JSON.parse(localStorage.getItem("thisProjectInfo"))
      : "";
    if (thisProjectInfo && thisProjectInfo.hisId) {
      ret = thisProjectInfo.hisId;
    } else {
      ret = localStorage.getItem("headerHisId");
    }
    return ret;
  },
  getCurrentProjectKey(key) {
    let thisProjectInfo = JSON.parse(localStorage.getItem("thisProjectInfo"));
    let ret =
      thisProjectInfo[key] || thisProjectInfo[key] == "0"
        ? thisProjectInfo[key]
        : "";
    return ret;
  },
  // 是否有特殊字符
  isSpecial(even) {
    // 规则对象(flag)
    var flag = new RegExp(
      /[(\ )(\~)(\!)(\@)(\#) (\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=) (\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/) (\<)(\>)(\?)(\)]+/
    );

    // 判断 even 是否包含特殊字符
    if (flag.test(even)) {
      return true;
    } else {
      return false;
    }
  },
  getCurrentProjectName() {
    let thisProjectInfo = JSON.parse(localStorage.getItem("thisProjectInfo"));
    return thisProjectInfo.projectName;
  },
  getCurrentProjectNameAndHistime() {
    let thisProjectInfo = JSON.parse(localStorage.getItem("thisProjectInfo"));
    return thisProjectInfo.projectName + "(" + thisProjectInfo.hisTime + ")";
  },
  getCurrentProjectManagerId() {
    let thisProjectInfo = JSON.parse(localStorage.getItem("thisProjectInfo"));
    return thisProjectInfo.managerId;
  },
  getCurrentCustomerId() {
    return store.state.stateObject.customerId;
  },
  getLodingPic() {
    return "data:image/gif;base64,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";
  },
  getRoleInfo() {
    return store.state.stateObject.userInfo.roleList[0].roleLevel;
  },
  getRegionData() {
    let regionList = JSON.parse(localStorage.getItem("region"));
    regionList.forEach(function(item) {
      item.text = item.name;
      item.children = item.child;
      item.children.forEach(function(item2) {
        item2.text = item2.name;
        item2.children = item2.child;
        item2.children.forEach(function(item3) {
          item3.text = item3.name;
        });
      });
    });
    regionList.forEach(function(item) {
      item.text = item.name;
      item.children = item.child;
      item.children.forEach(function(item2) {
        item2.children.unshift({ text: "全部", children: [{ text: "全部" }] });
      });
    });
    regionList.forEach(function(item) {
      item.children.unshift({ text: "全部", children: [{ text: "全部" }] });
    });
    return regionList;
  },
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  },
  //识别身份证
  getIdCardByImgUrl(baiduToken, url, succCallBack, failCallBack) {
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open(
      "POST",
      "https://aip.baidubce.com/rest/2.0/ocr/v1/idcard?access_token=" +
        baiduToken,
      true
    );
    // xhr.setRequestHeader('Access-Control-Allow-Headers',' *');
    //xhr.setRequestHeader('Access-Control-Allow-Origin','*');
    xhr.responseType = "json";
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          //请求成功了,拿到返回的数据
          //let tempRet=JSON.parse( xhr.responseText)
          if (xhr.response.words_result) {
            succCallBack && succCallBack(xhr.response.words_result);
          } else {
            failCallBack &&
              failCallBack("不能识别的图片,请换一张或者手动录入身份证号码！");
            return false;
          }
        }
      }
    };
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack &&
        failCallBack("请求接口失败,请稍后再试或者手动录入身份证号码！");
    };
    xhr.send("url=" + url + "&id_card_side=front");
    //  let image="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wgARCAC1ASwDASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAQMAAgQFBgf/xAAYAQEBAQEBAAAAAAAAAAAAAAAAAQIDBP/aAAwDAQACEAMQAAAB60WMaYMG1LiWSWXcMlgGlixrJq1qFTJCQAJqC4pC4pUaKVsbbJe50lENNstk13xXXURF41WUlx78eplsBQyEhrBkxMXSV5ZroCpmyRC0gSSAAtCtTQtWDWZIbk3XZL3VcJBTSQZri1lWk7Melm8Es5HZoy55fXS2Xze3rWz0X5T2aIY2havZcW4qQiQMqA0MSoV5Kz0+fxZ3j6Bp+caU+gnkdbK0kp91XXh1NJqujO25YVlKaOR07kP5XTmho4fTxvSRRaM5uvUapOSa7bEaJZKlALVUC2A8rgp1rs9LVp56xcH1WS48n7TxHR68/eCpnN7ENt4VL1mg5T2ZIEtMO6jMO+WM5mXO+6eL11cea41nNls6Zz5JrpnnbbGGlpT5/v8AlzzHqfNesmqdBIx0o+Xjy2Tv+d7c/oGnl9NyaxV7ORRlFN6tZBhMmqxsz6CJUZ9tpcW6Wml2uVXGFQpwFtIGSsJ5T1vBXxnrvHenOygo499zMr7OZ5Xu8rrn13Wyuvnc1DbOcttFLVMZNLSzm9CjdZybVPzrg6NZzrDj7qWuRr3vXkzqGOKO9nXlK9IDjZfSsFuJTztPQc+XFp57uHboUztq2kO78DSUuHtzOrMtylq1dri8FitpCAw56OwJrj7NbprEnqyXzV/QFceXsWMW2EkIDyen5q5z6W7OXTO27OXSlW01MPP7PN7cuhq833OnLY7JplCnqVbKNuBDYEMKmGVhreUC1Zo2AaBhUXEGRZSCFaeV9dW58v3ttJMjHiXMvUuzLxfQU1nz/YbWy2nHqlel6lXcXYhFKZMKdZ6kwrjqni3Xrnj3mupBgx16M5eI9BbirO6PObTsHi4z0s8s2z0U801nur88qz0SeYpOweSw6iWrUasl1cvpqM7KsZi2SzBOlLnnzfVcbHWms80yaspjM7z01Ez3dDLd5Ki4FFoKBlLla2LuBS6wVNVrQVJrS5ekJDLaRAZJBeSqGQgklF5GpaSUXkstaSiZEza5CwkJSRMj5FXWQoJBS5Fo6Q//xAAsEAABBAEEAgEEAQQDAAAAAAABAAIDERAEEiExE0EgBRQyQiIVIzAzJDRE/9oACAEBAAEFAla3LyLea38Wasqyty3Lcty3K1atWrVq1uVq1uCsLctwW4K1uC3hbgtwVj4HF75R2OwOP1/XpoHFH/FWKXGax6rNAoL2ODg4j5lPXAX7dEdGtpqrAHQV49/PjPu1wu10u8+kOkSrTD/dH5LmrV8+/wBZNRGwiVryTQGqhscLml1/m9ikOsDpHEZ/uBdokLfJu/WORxl967/dpL8kpqNocC07h7zwu8X8Sn6iJi+/gUczXq17yOkcM/NC6VDG1t9KrADQ3mvCwoK/hYXBXeOl0bUkgibPrpJj3gOe1RaqWN2m1jZl3lvSOGd9rtdITRouQmaSnysaQRt7RoJsrCXODWte1yOojYRVWu8e8GlrdQZZWhM0ZKZpY2rwNWq0+xMcQtHqPMxem4OGd+/fS8DgT+LYHAqeAyyRDa26RFtjhLDM0vZBE6Muikcmfjfw7XIWrf49OFpGi2uacdKVokj/ABfpZfHN69MwcNx2BRAXrNila6x6Vqzm8evqjqgULQxnlYS0hSytYQWvWui2SRm1A7dCmYOG9DlUuj5juceI5vI/tSzuY77ohfcP2XQilc90z3NjifujfK4SyHazTSukUkrg9psKsfVSohb2cjYEzvYCqWubuijPOiN6dNwcRr8cdr7doVWGxAGk6MPd9s2xpWhcUImtc9m8MYIx4wnND2siDEY2PIHGfqv5MNPiPHpm4Ftr1q+I2LQf9dN7RwzPSA47Vql38bzxi1xixj6lAZI1pZN8ZcdrZXlNe8410huKFzpImeONNwcR9YPTJJHFzi2OORz5HdPkl8jXu2MkeUyWQyOkkGodJJtje/wQb/J/6J3OGrcXeDRvJGnc7yFr7j/1EKX6a1zmaH7cAoAZGjj8ghYH4HaKKZ1kRNGPGwHteGPd42NO1tjTxBHTxEkMCHjDW+O9jNr/AAhANezxMWxtloKrDiGh+pjcxAlAlBeeO7V4BwcN4Vq8DHNDudm9+rsP0V3E0eWZhWric5tE6PTMImfH/wAjVxO3aYEQ8/CfWtYm+fUvMaaOA1ABOTow8M1ksLhqmEWEMFFNXRXapVgIBOja5CJjF79qqXBxQVLm1yieP6lC17NbFM6kAqwUUdfC1H6kFG/fG3tHA69egqXBx74K/b2O/wBiFa7Xr38CnaVz3x6EMk8a2FBhWw2WJzP4/Yi/tHBNsMb2jgfiesdDg4CaUOUAuj2ucdL2u1yqxXFc57Rr4nv9shVyuM1x6GOs8K89q7V4sLcCtwKDw5BzSvI1eVjnCRj0J2PLJmSEOBGB+WWoYcQ0CdSaipHSlumi1O4N1RU0zmyGd4hilJlWp8nijc6TS+V/9Pg3Wx7hotKS1uka+tM11aUObLoaE2nAbqdJt8unGyWCt+l41OnLZJtP+enPkdpxKx/R5odmaEH7gIzpjtzOhwiDUcT2EwAuMO9kUHjIgFvia9ogZ42wNa5PZ5GsjbGzwReKKFkQELA0aaFjY4GRIBoIY1gEbGJsbWkNpUGilXNckfy6K9E88Khgr16XPw6V8cLjAXpWrx2r+BOLR/krV0rXF2gSjwxgN5d3XCHfpdK1+pKvlXhrt2KW1bLWxSPEcuznatoW0LaFALg2hUFSpUqTh/GPmJf/xAAiEQACAgICAgIDAAAAAAAAAAAAAQIRECASMAMxIUETImH/2gAIAQMBAT8B3ooooorNll5eq3fTGNEY11PZ4jf2Rv7ym6E3WqS94aFG1snYneU7G6wneEQ+cUJVMkvnVIS0rRHjEhlfsmSdvVJkf70pvDHJ97Ies+TC3WzE6ObOTG7wtOaOauj8ioU1my+hacEcF7FFCiuxdNll9P8A/8QAIREAAwABBAIDAQAAAAAAAAAAAAEREgIQIDADITFAQWH/2gAIAQIBAT8B50pSlL93U6anepInNpGqfm7So+LcKJwfJqDU3agldpNkeTdP0LjelHkPnbT8cnB/zpb9GRRd6R5U2yEPENdycH7MUYi9F44swZgzB8p1ZMyZkyv686f/xAA4EAABAwIEBAQDBwIHAAAAAAABAAIRITEQEiBBA1FhcSIwMoETQpEEIzOSodHhQFJigrGywfDx/9oACAEBAAY/AsaBWUq2FlbC39JdXV1cao2GBChWV/rhfGuii7YSoVMJxK/bDbVTXKsjRROi+EYjr5NeWFkfMKosqvUKdADnXKygzhA4jSpw7DTH9GeyhVNQp+qNfmwk2nAQRMc04j08xZON6Lnlr6kMD10111eF61LSPKPZRVdVmUbYZsqhVUNgC1MPQOdlbCunqpXLEvJUNOVuPgML1HsVBo7yHLdWUqMwqVe26v7YAG8xogOupJEKhChxI9tHVd9ED0iyheIwrL0hZ2qQq+oazhQYCG7rL9EOhw8A29RQEZemBQMTzqoAR5FENbFUPDGM6Hu3UrMVfEhQmnH20Fc8LYQqrr5nfQG8yhgG5b4SRhmG+DT01O0W5KUWmPrg4ZaBpcOqiWm3iATXUg/99sIcpYJM8lJvvSEQNiESjm26QnAbNm0oHQ1DuowKtiUNTtG+y6KQXFSVNqRKnM4v5q5A3rdblZoaPZR4vZQP1KtvKg2KJEz1UlsnS3sgcbKuBPLAanYUwrhCk4QNFfKzC7cOqovSqtw+GN0GboN5anKhwO/RM6iU4hdMHZSYaf2/lcOtS790DMnIEJLgCU8S76rhZRsnuJrT/RQXblfJl57SqPK4btpTxPyzVS9wVjzTe2Bc2ic7N7KNHxDUrNFdZXNbhbFemCLKv6qQB7K6MtqhAtZSB0QhtV6aqsclNIKpFVlgRyX3mX3QsQvSpgd1UY1RAOF8YzCdB07YVWy/lbr+ExgNTy5Lh1ojPJP4kUFEwyZzBNiKVTxcZqdU2v8AcuG6pus+doHVNnHorIjhg8R3IKeMCGCw1Q4LI9pc3mp8Q/yqdJ74/NhYKxV8JLQSvC0DsMSrYRhGP/OEZCAgxsz21/MqMP1QPMaffD+VdVxjyOqncLuowric32UXu0oOHCeI/wAWqF+EPzKnD4QQG/Rb6PfyZ8iNJ8qVCGq2korbXXVdXV6q4KOVwMKjrXRDXA9kQ14JF0Q14KMGcuM6y82CbnEbHoi0AUss+6cHXFaIXjssrZiNgmmubsoM+4w+7vP6LwOOa0uTCXGSQJXG4bXGhoTWFxS57vCTVcZvFJHhm+ye6rWO9IK+0MzGc1Ceyf4YDWw6DMlViHsn/wBXEDMrszZBbsuDk9XwznhO4XDLXiPUAuEG+oNOdc7yP7U54ygxlDBsFwhlMtYQ6ic/54o2LIte2l5w6hAqPis/Mvw+L+VfhcX8qmC3oVdXXXZCXCN6XTiTe1FlP+1OI3TfETCqBP1Q4ZqAswEdsMslvZZBQL4UeFeBv1KIyjKbhODWCDdH4bQJujAiUQwADonZWgc1DWgc0TFcJUxCocP3VlNZV1EKw03wjAKdI8jthVFXxoijRUVkdl2QcdJUKFPkBe6mMbq6umsiZ3nTZMJ5az2TOww//8QAJxAAAgICAgEDBQEBAQAAAAAAAREAITFBUWFxEIGRobHB4fDR8SD/2gAIAQEAAT8hfpKBkgCDJhgI1YjsJmBvBgU0PEBeHkxorkQGdp4H0PwY3EzlAziB3mpjM5w/8Z5viJ38Tsx1LE7gF7+INBnTvuDgQIw+YD/6QIhgg+PUo4TDloMEg2cxroEM7YrEsutDmLDhpGepeZnhudiAlnEYFAFwAL6J5gAM023hR2TYCog/DczWzZn6CDREqDEtkxAbRAHaMITBSo3qYEmPvCi+9RW4+IBYIKb4isjIlhgjO3Ah+J2yoh+1wyAl6le5rcBwsUTCF2WO5gAVuIdBH1gQDcxrCCpQCKhDZz8TFQQC7IzwZYoZwFUY9u4yRRNM52dTn4Ep7rEOUKOYRaDDiRuU1KwqmltBZK6IlsxyCUF6i5YtT+OALQ3MjGISdIffp+g4WNzLI8GEAwUZdpRljECIfPxFFdzYFRmuPMCUBwfWKwIIlcQLLEIaBKAcJCVGU5kxkH+DAKDgTBzgQkbwLjBrcs8ODCfc8Qs6UN5PxOjsQDCOpaGID11Bap66gwcCoCNjcwAuBoYyBKVDx6T9DiDLaCQGoamw4SEIATwhqK1SF35gbAgGqjIHAqs+NTkAbHMGgoKh2C/3KHB5mXXJ5PtKpQFgqPuHKFa1LhVAkGLelc0zUYe5T4Jj4dmIUwTmZqARGLHMNq/YQof7CHRiADO4WcDzGKx7NwPRf2gsFgICdEEOA7CZPEvE3WYdv7UcKOY3MUnvrM0AAHcZ4AHIWIG4HRa6mQrY8wIIzdbg7ZyFZBgMiBOAlsoWGVnILPMo3FB9UoDgfKP4fMCVnWBOiZVX4nbHEJ5rmdKcmHZZ+sLHPzKsUPPGImsk+ZWocRCPEfgbmHwgQHScOCzX3lyj9WpoQMXkJdwVdwkVgLYcbdRBn+4gFaZUlEMnBSAumSDY1CKWoHzCndajLRAknTgfawohxATyUKXFSEdCB5KGYFsGBsAxAuxjqFphpKx0zM0cjBjIyHGAwiPohqEMwGCLpNTPmNh0Q5EKAyIgl9/uCCMfYehXCYaTxMMTMcjqK5OD1iCoABnIFWvvGB2NRiag5jQNHw8TBwsDgL/Mag8hv0EzkK5Z+STCHwbY3Gisl6hxPBkcLj3m5gS4gQYjpHOXBrbcIpDViEZbiyY5moEQMK23GmIYmMCAbhICyILaNQBx+ITStGBHpB2hWv5Zj9Bmd1iEAhiCOj0SbCKYgI0HuZKIMCPGAH1mkBuxABhmCzcLUIFAZHAUs2OdQ7Q+IOw/ECNRusHUo9RQAjiVkG+Zna/TIZJAbgFWBHKxtiFBDAjczpqDShYiYVffMj1+Ey+vTKHEH6EJKXyYAwn7TgpwVWxodnmIKxIGBFgAhaH8yrAkEeYHrdkAv9jyFk6K3rePrMvEwCRuLJAJUSALLmPNCmTMVGYE2oPiFXAAAr9zDbAd1EvIBvl0ZozKHa/8nyJ9IP8AkFK3Dl6ExfMRNgDFoQDDViWkQbaAAWBFCDILioH6BnwYX59MoYH2/mBgbonPEIZB/c91a3AUASZCJ1VwkhrXqExqbPBiZPaCyEnQUUc/aWiCdX/kAJ5YbO4iIUY6iMMI7QIyIIsGhhbdbNhZjQQyOAmzCAbyQuzKmThAESr/ALzMACgFMRx/A+k+vTz9GBC7jKgkIF5lNPIEOEI8AhJwCCI2Y2OfMLt6ZwiCx7ce8AIbtbgu/BRimDzKGYEIJBWuYVSX3AgNncZzoP5gIBR56lAMlkbjO6j4qZUcBQHQqV/2ZRhj7TpzGXzkZgIiOPczJ5ihPRLBEsNCjBXsZogmIF5jqdJri6WiX0hPOJpe/wAes4ga2GJ7HmAXYXY3DwQeAIDiHiK+JA8QRCScx4S04wOP0g5pMh8iBbDIDtmHQGg2C/MARSUEBqYm80f74hJCBKkHpFvyyp8GWHWjKAto4B/uIK8QBu03v7xAgJBiO24SAtpAtlxiEG7VruOw8cwBHIh9b67hrXDw0QlARsoTKL3cIhHvCUIa8Td2PQfR286nVbTF+AQok4Mxei5CFJIRhApTgcsoiBXyjCsIsnuBHRh7pQAaw4hFJCxBAqXbMKNSFj9ozGTGNyNjPc+wdUFVJMU4SK4jAQRSWNSo0cBIXoZqxAmIcVQhYTocxwt8CojEsoRkmMLgxdwMt6AdcSoPEcxhxDQl25cWSJgQ763Miwy8QAbGXGpeR9MJk9wsTokBQbZYIM78D3hmKgSyhXuf7MA1kg/smLpaKPzDcaqBrMJRgDZge5vzFjqIBYm9qD8kUUDvMIQQhDwKiIAYViIIqMV0J4CAWWF2Il18hDQdvE6VQtQiw8tCBhnUwzBj0GEKWITg4oJagkjMsoxAXCLN6/PphMIaAbh4D/fMo77b/csMpu4CJO7wVD3IkDV4MQW3FwoDonAJECAkhWL7lQdOaIQEGtzPNDcQJbC5hHQR9p0QGycwFDg1Nh8hai4KzGbuMMhdNQIIgA9iMFQkYEIs3DyhH1KiKUhxIiKxLjw7glFQcwwEbIEcsIcR2WYOX3cGH8MwfleoCtBXMOgL2hBFAuE5BURAOIAdnW4iTxUsd9VME5YwbjDI/EQ08IzAGmRARyvNR5XmEE2UQAowWDKRBJImECRVH4+h0PmcivMI/H1lrQyxYezjT7gswCkhBFmy3CZhDif8Eb8AoWBt4gGAGOJaBruWWIAjR+YZdguCLMVuUsNRHyygqIMS4R7OBMNgGAMfSZwwRoRariMbJi8wgeyaEoBwYdiA21Uy3EE905u9QkHdGK0f+ymUrcbItgwF8jsCGahFQXp3LYYsxWvhAG/Mx/fSEBeYzWMwPFMQxqAokMNCGhP1cJCvEzjzCQDwBfmGw4MCCHITg4t5lg8ERb4WIC1anN9ThLu7idAbgeQV3iBjQhlWoJQMGdwHQpkHiAkBk8kPqfLwkCaAxELOAcQCBIkVCk3RlEkfBhlQCVGP0MCjW8wNoo4uC235ULwrDcKKAHZnoHyIe+BUyVBZPB1DKoHlblgWowCd/wCVOWgTy/5Qjyyi/nlRj1IK/BL6qGoOFMhDK04e7MryC7xGsrG1mJOYE5kEMrEHnEEsDDlIbB5i1CwlMisy3cCBduNkrf8AqIVu4BHT+qZJyHB4lKg7E6z7uDuhysQeCdwl0KQFH3mkGIo3d3CAMgvyQCpkRZqMejRgAIJgMwHJhRAs4mhDyTY0U1DkmjpOE8tNfG/2K9nhcB7XBgPRs3DzA9wA3CokaUvvOXL9xsND5iQoJByA+kox5wRlJQHH7gMEVNBPmIomE4jYhVBLB5gnHuaKg0EBDT+8V7KCYQg12WEmWZEu24MqBVZEFsugfeFEJHZWZwERS4bI0RgETMAKwAUFStmr95jQnAjI59olxAPp/kQjo7gFDsvNGUUHjElEEAvY1O5EAliDVTLM8VD+g9M/MPIU4SQxGe5pYZLgQbeBAykEasrmNJDwE+8yAxFeuTuUKFSjuAWUBBBFXEMLDqJ77gI4EVWXOTYGO4wDdnEFHhILQwckwYHI5hCNxD7lLHNSzgwpTTMy+IBZEEagLDj1MifkKhpdg6hPZCCUA6XooQxAQB04QNHUHhZmw6cZCqzODMGOcT7JjlUVruFE+saJrzAXsjJRcICqz94NeFAROZzjBGhhhfhIQ2MUKzXc80vxCswO8E5TrnVCHEIcQgj6AkeiUNjn7Xp//9oADAMBAAIAAwAAABC4borKseFEWllfbmTkilYdPUtU3a0W3lfEBwSHeqaxJczOESk0wuK2R9CXJQwp1Ok64g2Ui+DkQcVqr/F34WY22jkOJg7Eb55WYSTmuI523WLlJwi+xotGFK/QhsKKKy/kTz4ka10ZSgSsKo33/Mpiob0pny1q7a72UliXNDG3klANxAuY/wD2qym0rEzbAsGeZDQUVNJk4M8gPW0c4fgigf8AYI3YIHvn/oPXIP/EAB4RAQEBAQEBAQEBAQEAAAAAAAEAERAxISBBUWGB/9oACAEDAQE/EJf8tbWFhgGzzmzZ4flvQ/YcH4J4eH4feJrWYfWCyLLOZxP7BL7zO+uJ7iaIX8t5T7M0+y8G9bNHH2NMiT/bI84+8MRfREZANIRrfIUhOEftvS2cf+5YMjjwDyA8iIA+Fh9iAPOP7PNGR8hjC/yESscZ8iGL9ghkIg5llkspyJMn1nq9IjgT/wBtjW+LM22x8t6fXpHB3OAZfknhJ6/B9tw1kDWxCj6pCEW8EXjP6Psl8cjWYMy9GcyyCzjJZBBDjz+xENtq1albXh+f/8QAHREBAQEAAwEBAQEAAAAAAAAAAQARECExIEFRMP/aAAgBAgEBPxDjbedtWuTcQeMs/wByI4focYQrqWH7NYJ/mxGOTguYwDGLCB6iDg9fBYLT+zrZR8qu5OjY2SrGdYcLGvHqXgS5keW18fKn2VfeVX2FONXj1DxINR11HFEckk6Exd5KWw29W8djbAwV28RHOc7PGw87fm3YIdqCaJthH+wB74gX8pT7wW2b1DOWgt35JC8ZZJlnDILLI+By7turJ02f7W87bwQ/ZfnwFhAWLCw+/wD/xAAlEAEAAgICAQMFAQEAAAAAAAABESEAMUFRYXGBkaGxwdHw8eH/2gAIAQEAAT8Q8I988NYDbwlYwHR/CGTIlGm/tiQGAWL48+2ceaiD88+MgRIkyYfar9sNZCmI2emEyCk0Q36ViiPsEqe3x6TcZQFMGuesGz5NJce+Et86svBg2PEk/E5U2qZsr65cEMtGLhkXmcEopspmhRZ8YkQyJutZCW0m6165tAPUJkQloyiZWp05MMNK2pwUEosbF9ayKbSoYTD8YPFPoDOLgMupYxiT0nCULdO2KJPJCZZU96YZNXcMoEdqcJ1wOT5xNfM5TrUziqhEiVX/AGMrRbwFZTI0OrucIXzG30yHCVISLJ6HjJzTTpxrswjYYUdP3+M4jpsyfrE6yRy8WE7IZ3VcYTYJURM+PN/vzhBS6g7fz/bwFZRDch9MQlCodXug+MYlIlClJHfuZGFA8ucCEKkyLWREBFhWvzksoJdBX0xAlJiZnh/f0+MgJvaaIfv18YqSur4H1yiIZJQ4/GPSBl7/ADhOoNjtz3oYyBISiq6UsnBvjAwBgcB49qit5CMImggVwv4xANGIbH5+3jKAiAUfvftvxlBATjkXhdv0NYJEIRhH6o98RcpsGL9mUyAm1iew/wAxTiq00JR+sezm8vE4r0HFRMSjrK2Q1IdmM7qiU43DPpx3lNXSJOF/bK1rhBdzXyORtHsE+l4hE6FjDjIElUtg9caBoAIh8euHRICWfrXHtgXGjSz/AHCgkGxyhGWyjH+ZJK6zHhvZ8YJrJJ4j+jEjO8Y6Qf5iKNllkN4A3pin2xUeFl/uSABlbw+D+1gJErzL/ecUIGyRMYKUiS2G61kkrGgDnr1vHESBR75KhpwaDCEn31Q5URKoTr9d5JKQjBE+v2yEIDaDpPPvWGmHTQrAdGAVvLBXdGusBFQs6GP6MUEdin1yGQDe+8q2ffJrAun1MtmO2dOC2ABIrNcmWQGhTnh9/wB4wNs5VHI9t+2WSIATPP8AmCQmsl8c50dEhCfGDpwFm+3Wt45EEpIKUJ9sZe5dH4cJ8kgL15wECgqLPtg8BdJxP3MWEAJNyf8AUGTEmZ0eV/zKA1mSJjNMUWnKBpXe3x+MEWwOWWePbX1zqGDhf9rEzFht5w6XSfz6YQxUoHmevqf7lCimhxnEYbJqMS1ANmYJw70ORSPXERi9YGV39a+uNYvLqJiPrOSSDEDP1wOCrvNoPHE+mIgQWQakEfvGRGPDzhhSc7zT2wEpHR5MSMK8ZwRCSyJiuH7mEJBQSwefT7TkrGKgg8CgSCK5nBPQBTa1Wp5y0O+3ErBgoADdDAghGCVAUOLXVDiMgrZhNgSTFsooacQYNkGj2sBzeGmLJiALsd+O94yyJ7A4MdAIIA7e/bvzeMDKREseC/v5yFAkSErZ/XlRJM0bg7xZmTKo9duFMtiUldfH76zRVIsZiT1+chkpfCchaolMAGg8iX49jLBJTM7RuaxgGNo4H8/8wISeBXPpjg6KCPbJNE2YaGQE+KbDj7/THP8A65P3fpi0HcSS/jGKlRkiESc2YghkBluIITn1ziEsp3phS8uJxow/9yKpbCheTrLtqLfdiYdtk7+mE7KgmLDniznx3WDM4MkDbhEvf26ygpWbgJ+nrFCZpEifRZkICC6T3YlwJIgIAXx1eE9RABAwHway7Mk4AI+/GMQ83pv3ebcgTB5Wf3PpeElJQpABH9378Y0RhGxMvwd7/glITAuHSdf9+cgqbLye3HtkSgqgGq95r94JiDLaiB40/wC8mXSe2RDGIggNHj5wJIJYju7/ANxkg5AiVF0ca/eBICdSJmLqG/t9Zj1DmSV6/wCGOcCnknlwu9w4QSQ9DeOKkWScL2i5JhBqeRfo4ZHY1pD43kpSE8LhJLGolK/zPxjZLOn6H6wYbcdmKwrk5tumeevbCG9pIYn64oDqrF2cm8pHfQ99bwBZMgSEkpnXB9PESo0ELhj6euT1AimWlVF4B0ypo9d4a2OGLSbS1QvzhoFgyH4+MZoIgJv/AJfPxhj3ECxrnFfgLLuKoGstxAD7B79es4l2hIbmE+TxXsZKc6ZGtsxrzODyKEUruc8YXqh/zOU7UX/1r6ZEZliGvSOuuc7AntH4wISGpDjozSjbhv68/QMclTFyvHff2xE88HD248yRuOXCwDxJYzXP7M4z33oDGSSNRxiw3zJT64MeAg7h3k4mZOKrLJlVNIesfONiXuv3wayp8Xkg+TEdCwcnLk60PlcmICN1WM4kUFjbX5yUNGZjKLXWCkFaJCfE/nG7YCdzlf1gHFlrsucCQzASXWL0ieJyCnhEQPR6rGERl4W5MactgLmKw6zCMlaU725PFUFhYqfUD3clNoAHs1c7ny4VGYTCbZe4S9TznP3FK/RjQEydjzlhIFl2fHf6xoBNoD/dxjrKVQRhREjqt4i1ZaceuRo+pEtfnJKnT0yQQUJ585LEsq3DTRk4xKG6JxK0eHeaC2ock7Ch+NZEIkiaJnEiETofzkzUsDCneOWMVVlVI4kzHLkBmGoVyhZSbB3ikiTSrGvXBQSkRTXDil6Skp3g9ISI+cF6SsGGKQGlJSX+mcEXCUQnnn4xs5gOL1OjJMxLSn0yCujfvyYVk2AnacOEtQpKNSlfjEEoXU2HxGQik0cfRkAAeZl2/wC4oU5EdxX0/OBZAAjK0nHr+sDoba6POTwSfd49MW5kiL17ZfiMj3Quc0kGAcI2JrF9CQSsd4ZpAj0yFVEQlE/5kRRsIhOcmEKnxiQDYw4XJQNxrFbiQaUyRBRGff8A7kuHc9IwWxmGZlgO28Sx6hH4wxKYYu/1fxlwoD4Rvqj1fbGlxjIuEouhABD694x6mRGX2mc1O4ZmpZ3fjBlqbCI/z3wKTMGXRkTWl3k2/iWgHGsp4upcZa4RbSWGXVNDPW8in426TpnI6Zi1CFY2bIjd5LZQ0IAWCJgVyjGCVAsipj/g8mDAsg6Ym4XfWLKpd+h2rDiDJQNmDJJMVTz7ZL5BLKJ3hr9nrGQC0pNT2yc28zLrxkkLcOK9nI0Q/I8e+TDtg0+2CWVF8DeBKkIV3hKGKu8KkcmgQ0RM+2LilWjeKaEfZzhFCCayUpuCpyRYEgnpcaAZG0Ptg1vDB+mQS3AiQr4jzwcNgbiQPT4+ffKk1VlvBPs0YIELKJV8Lj4PXAkkAchwmZgmfn3xSmZYA9UWPrOM9gBR4OQPhxUpMQNWXdmvplDfiCUYRzSzE0tiFgIQIiltRtnd4BbIviSZkVfUTg1CDlCOuPs5HWQk4JiNPOQP1TARqL77mpGZyCNTeUaV1vxVRxGLzY0nk3Un0oxR5oEJOLQKJLg0W+esE6E0SxLX16ephAaGEExB3zWENEl5Ah5xlNsu0Jj0yUiDwXX7Y21GeCMQK0FfTJkUu8mUEqSayCzxWy+awhojEIUnxjqiO8MUQrTua/OMl55xLgIkMe+FuiMhIX9fGAQgW71rj4wd4KYEecORMqTl6M4FCxa+H/mBQlPLB8bxhidzQD8fPxgkAkR9bZ/HecBR9L+8lgjqNe+Cxi2nGPIERLD/AD84iH2U5cveQJeorh9OME6Hgd+/+YGQiBLefGQgSC0dN79scghIAD+48YKpBqLTBgjQ9gxjJuaWn/mCKhBSGp8fXIkyJPkl1f8ARj5F6nxiAsj7mTwMAdYfV2EyPjAokR+HEBIwnWRPOicklJqJvFoByTDRfrmjVPW90YCWJcmjCWRUJ3gAEEbcUAvBPQl+smMGsE8NYii0lDfOMIHpNSMmK6dNi2QwWVR/3BBissWoueJSckIuiO0YrgE2JEzE+cEBBLSlYyCCLMSnHmS9sdpQOQFPoZPg2jzCft8YeACJAEnsPRhJ8giQATN1FxPGJrGIoQFzcRcveAFQUSInpMy44YYO4KLOmfpjcrLfFKe98T7ZAKrAgu2F1+2G4OQYSS+3fqmesUjeCAqWeNmFBElCHTE7Y56cBDBaogZO3PNYk9MrCbowmIaGD+8Y1JOZ0Ev+4XFMuFZx88TjzO+sIkOu8h5TFuUwSo6I8YCaiKZoKyta7HB5xeyj9T85Tc5IZpMecrFBSEJ4yFJxzI5wrERpLM3TcLT6YISjRKA1+KxNSGNi/eBDXsCfxiiSSog5HiFCTQO+gyNdKcNG0fH0xMEikeDIfLkEWeiqPeKRAIGfq/TJJ9AmG4fBOANpEqRIQT8HximUYdhmR9frmkJTql3WMwqEAJgS/asBIu4K6T2xTC6AohEPT9mCvE0j8PGKBoSga3vBYwrQ6OvzjlCk2pWD1NitB3idGImZPhxgG/DOHI/DhRIPTGoqhnEjio0LieWIRG3kyhQSLk8YaBkHl5MWMYYDxORU4g0RqxCQe+bPAlflxE2QCCD6axCBLCwbPfxkBPbEkB64CLQuGgct5oJECRKwApQJDP6c4CS5Q950JVs4h1i3UcQlRIlLo8PJM3DGSxJG6+Sp6x7N6aEpt85CIcmknfLBPjJuDhkEJIg0tnOVc1LWiEStTiIcQuI64DJpubMQNSYsXhqfOWOmu5dCNyhnJfZiIUbuIvv0yxHJG/brz9IwZWZTZbfucWYQLrqUk8+DAEg1VpGvON9/UF5TWT9UJq8zuMJAR7YbENajBuvGQm5MNgnxgVC6njyPDkQBSX/THgfRV94jKQl9KNy1WXJEg8aPWLK384d4vKL6uQo2kXHB5M7RO2f1LGGLxbd7ZsIHMG/B/fXQojRJSmKJhqIxC1vf+BWBeoa5Hy3/AJiFjzWX7P8AcDl9IjyyVzXR4yDl6moYhMa8YeNq4JOZjIDEFi/bAIrEzYhebvU5BoMBDIdzsn4xIUq47dwv/cKwETFlr4/p9MiYIiRbrrzlfMPqO+uMAKAhIG3n0/W8BgT5Ab6InzM+TA6QZuj138ZN3KXFCNRKpDmsmNSIu9iMPJ6gQvtwJcdmDBIhMZziUmyMdId8zvBt111kg8ISdJnJMwHZ749CjUR9jEdDaupJ+TKR+QZ95xsxhlwdm8gkkltBADU5xmAtht8ViVEY4FDisQNhTFm2/OMegSLjcT93A00II7dayLpCIQtnGhGVDsXmcCnW9x7fvJjmQAOG9eWPbBdwQMYhbrFE4MHZCJJcRlg0393j2xrBXMad+K994IQR7C/8yQyFbqgxI5hZPX2yQwBojnvFAoQrKLQ/gMl6ZsNNf5kxwg5ewWKh9cgquINe8mfskEyTAITD+7w8MxpcHI2jyrJUIFPSL+eT5wMBs6HTJpAglOp4nGTDGb0+0YhSbVJ84YscEESHBiQ4MCdVgTYYLB1gpV4bCoSZ5UVggpnSHJPaBpXoOCoiXwnz+jIMKhudow7AQo47NALHDOBw4s/v3iCMMWJct/3rkgHaoeOPnfviE812rio7OBR84JpBHwfvAkOWKhjXjjy4MpWt2eJrvkyskifJ7+uQ2odnWM60bOciKmVAnPfpkCiVktTGAOgs4gkBMEXHpgAKKg8+MkhF2tzP9OKqp71OSlAWdR/fTABCIiusAiQREcVf/MSgXBbRP/PtiTBKtlakxMbVoFzkVSKEkYQEvIDx5wOQR8qv765tCkHUwylmjIwgp25EAbHBMcYgDyC5KEkRJMcVRSN2936weuSPoYAeOfwckxCKTynfquRCFIiScsN4pn4xqgW7DxdnvOMoQAC9f7l0VRmeLMr5V9MFcJDSS/Y4wQERJ6evO5wVCubl1r5+mADqRLnIItKZPLoyRINonZiCNvk/qyCyogRG3z8ZsoYCO/pgzBEEiUPphEHmszEPPWNyrGWCw5rAqYUcugh8YkLWiLDe2Jv6YQ64AF3zlfMbiPpxozdzFCcK+/2zcLQVvORh61oevfIAo1PjNzVL30fr848akG8/35xDHFZ76wQpE23kyrCUjYffBsolT8FyJlbLLRXf49sjcIsVFke1++NiRVSqswaFCemjZgwQLXUl4DnIRlwDMJ84uZMPAssA6gwqMl9IUQR5epkwERbCETLxqHTCoHle4JQUEHvjlOAODDyiNXzgxCFwJQTVsf7lpYyWbJKTovHCMhpLQpSogxTVNMICL4rGPUGlsW793GQEdjHP3wKJDMQGaornrjvITBRSiJSsLIxPHDMAlDIIQv5eMtU1EF7Ps5by8KAtgWj6i8DoqtBgEFWMzNw9RgVLAQ2/P2+clkyLl2CbeN5XISgG4OUr3kSQPiwNVblOfacoGqBE2+Sg+DIio+wWgPcw5EuKYVqhKW3eObhdBW7jBBfMB8/3rjKCRglX1xyY0C1VBXh+2CrJCMh9cmmU9Z93ARVN6PvhtqqYnLFS1jA0hQhBy8Y0oSAQM9EOXIJRASuUqYftvHGpWsWVYdkxUp1kpMRAMQT2iJiYvJ2tvCeCoe84S4EQgkAJasrfpqsRFFODVwsos9tGQCYBs4dpswUrBDKwJLXnr2wsN2Ih4WiVj2wC2Umy41/c4JriX0RJ7URGNYGFNlv1Kiz995Zp8k9SGfRnjC+BzoPlZWsA4KAkW0zuayLx7pUQySkKRxNYDo4iAg0fLJ5VCjLUrpclBNpArejblN3A0+YtcTAhFJPcnzlKyKwyheG7/uMnXrgj/EyAC9q/16ODqiBCh7D/AIxlzFtPQh599+LyYGArG46p/wAvIaSIvYy86++BMBfE+p9sWi2Gnjfi8QwIkinqw9fnNognC7HMYBubmQ3657vrgSVxhNAjAZ87xbouNDCqEDQ9v7xhgzFoBt3/AHhyBAQxuZD+MkSYKjijX0ycCBhatywAQSeP91howioRAsyR9N5LJimENH13xvzg3URSzM85BLMe3f1/zNSAltvGQFIdx5dYqLSyHupzYAJhS869+M4Bhi+MJLiaKPj0+2DEhHMiHycYghYnxPeM2IslkX+++J0kYnOIaCz+X6xoAZgRho/WSmERb5O2OcZLcciwk9Y2MFTg/uMVhiF39YcUFBwmk+ic/wC6xpZsFlL9Mh5AAmEfGMhJmLbYCPSkJTvJxIasNBz8GK1wmx3jDsyk+MFh/rx5hIVxiDCsJghoLHX+YkCISIY5/wCuAT2JB2kzhBVUJB7c4gAgCjgZNljT+jrHaxCZ4h/nCioVAPWR8VfKyesiKTISXfHxlRLEpvezCEwSRWppwBgo0lZhH4wXpWDCIz457ySybFgmsYAqJajfj0nCitQgrziTlRRRN6hnJqZdTORgQ6YoDh5y47LK95ry5+uB5aKbYXEOOMUwI8ecGNOtbwbAPjNANdYhcRegfhx1dqfhhWf/2Q=="
    // xhr.send("image=" + encodeURIComponent(image) + "&id_card_side=front");
  },
  //识别身份证
  getIdCardByImgBase64(baiduToken, base64, succCallBack, failCallBack) {
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open(
      "POST",
      "https://aip.baidubce.com/rest/2.0/ocr/v1/idcard?access_token=" +
        baiduToken,
      true
    );
    // xhr.setRequestHeader('Access-Control-Allow-Headers',' *');
    //xhr.setRequestHeader('Access-Control-Allow-Origin','*');
    xhr.responseType = "json";
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          //请求成功了,拿到返回的数据
          //let tempRet=JSON.parse( xhr.responseText)
          if (xhr.response.words_result) {
            succCallBack && succCallBack(xhr.response.words_result);
          } else {
            failCallBack &&
              failCallBack("不能识别的图片,请换一张或者手动录入身份证号码！");
            return false;
          }
        }
      }
    };
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack &&
        failCallBack("请求接口失败,请稍后再试或者手动录入身份证号码！");
    };
    //xhr.send("url=" + url + "&id_card_side=front");
    //base64="data:image/jpeg;base64,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"
    xhr.send("image=" + encodeURIComponent(base64) + "&id_card_side=front");
  },

  //增值税发票识别
  getInfoByReceipt(
    baiduToken,
    url,
    succCallBack,
    failCallBack,
    urlType,
    type,
    isStop
  ) {
    let that = this;
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open(
      "POST",
      "https://aip.baidubce.com/rest/2.0/ocr/v1/vat_invoice?access_token=" +
        baiduToken,
      true
    );
    //    xhr.responseType="json";
    //   xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          let ret = JSON.parse(xhr.response);
          if (ret.words_result) {
            //   if(!ret.words_result.AmountInFiguers&&ret.words_result.InvoiceNumConfirm){
            //     ret.words_result.AmountInFiguers=parseFloat(ret.words_result.InvoiceNumConfirm.replace("￥","")).toFixed(2)
            //   }
            if (
              ret.words_result.PurchaserRegisterNum &&
              ret.words_result.PurchaserRegisterNum == "91420106MADMODGT5F"
            ) {
              //O转0
              ret.words_result.PurchaserRegisterNum = "91420106MADM0DGT5F";
            }
            try {
              if (
                ret.words_result.InvoiceNumConfirm &&
                ret.words_result.InvoiceNumConfirm.length >
                  ret.words_result.InvoiceNum.length
              ) {
                ret.words_result.InvoiceNum =
                  ret.words_result.InvoiceNumConfirm;
              }
              ret.words_result.buyCompanyName =
                ret.words_result.PurchaserName || "";
                ret.words_result.salesCompanyName=ret.words_result.SellerName||'';
              ret.words_result.taxMoney = ret.words_result.TotalTax || 0;
              ret.words_result.invoiceWarehouseInvoiceType =
                ret.words_result.InvoiceTypeOrg || "";
              ret.words_result.billingDate = ret.words_result.InvoiceDate || ""; 
              ret.words_result.businessType = ret.words_result.ServiceType||"";
              ret.words_result.salesTaxpayerCode = ret.words_result.SellerRegisterNum||"";
            } catch (error) {}
            succCallBack && succCallBack(ret.words_result);
          } else {
            //   failCallBack && failCallBack("不能识别的图片,请换一张发票！")
            if (!isStop) {
              that.getInfoByReceipt(
                baiduToken,
                url,
                succCallBack,
                failCallBack,
                urlType,
                "roll",
                true
              );
            } else {
              failCallBack && failCallBack("发票识别失败,已保存图片！");
            }
            return false;
          }
        }
      }
    };
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack && failCallBack("网络环境不好,请稍切换网络试试！");
    };
    if (urlType == "pdf_file") {
      var formData = new FormData();
      formData.append("type", type || "normal");
      formData.append("pdf_file", url);
      xhr.send(formData);
    } else {
      // xhr.send("url=" + url + "&type=" + (type || "normal"));
      xhr.send(
        "image=" + encodeURIComponent(url) + "&type=" + (type || "normal")
      );
    }
    //

    // var xhr = new XMLHttpRequest();

    // var formData = new FormData();
    // formData.append("type", "normal");
    // formData.append("pdf_file", url);
    // xhr.open('POST', 'https://aip.baidubce.com/rest/2.0/ocr/v1/vat_invoice?access_token=24.f792b1e77fa73da9d32a8469958671e4.2592000.1652519224.282335-25920024', true);
    // xhr.onreadystatechange = callback;
    // xhr.send(formData);

    // function callback(){
    //     if (xhr.readyState == 4){
    //         console.log(xhr.response);
    //         alert(JSON.stringify(xhr.response))
    //     }
    // }
  },

  //增值税发票识别(升级版)
  // vat_invoice	增值税发票
  // taxi_receipt	出租车票
  // train_ticket	火车票
  // quota_invoice	定额发票
  // air_ticket	飞机行程单
  // roll_normal_invoice	卷票
  // printed_invoice	机打发票
  // bus_ticket	汽车票
  // toll_invoice	过路过桥费发票
  // ferry_ticket	船票
  // motor_vehicle_invoice	机动车销售发票
  // used_vehicle_invoice	二手车发票
  // taxi_online_ticket	网约车行程单
  // limit_invoice	限额发票
  // shopping_receipt	购物小票
  // pos_invoice	POS小票
  // others	其他
  getInfoByReceiptPlus(
    baiduToken,
    url,
    succCallBack,
    failCallBack,
    urlType,
    type,
    isStop,
    invoiceType
  ) {
    let that = this;
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open(
      "POST",
      "https://aip.baidubce.com/rest/2.0/ocr/v1/multiple_invoice?access_token=" +
        baiduToken,
      true
    );
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("Accept", "application/json");

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          let ret = JSON.parse(xhr.response);
          if (ret.words_result && ret.words_result.length > 0) {
            let retData = {};
            if (ret.words_result[0].type == "train_ticket") {
              retData = {
                AmountInFiguers: that.getFloats(
                  ret.words_result[0].result.ticket_rates[0].word
                ),
                InvoiceNum: ret.words_result[0].result.invoice_num[0].word,
                PurchaserRegisterNum:
                  ret.words_result[0].result.purchaser_register_num[0].word,
                PurchaserName:
                  ret.words_result[0].result.purchaser_name[0].word,
                buyCompanyName:
                  ret.words_result[0].result.purchaser_name[0].word || "",
                taxMoney: 0,
                invoiceWarehouseInvoiceType: "",
                billingDate: ret.words_result[0].result.invoice_date[0].word,
                businessType: ret.words_result[0].result.ServiceType[0].word,
                salesTaxpayerCode: "",
               
              };
            }else if (ret.words_result[0].type == "air_ticket") {
              retData={
                AmountInFiguers:that.getFloats(ret.words_result[0].result.ticket_rates[0].word),
                InvoiceNum:ret.words_result[0].result.invoice_num[0].word,
                PurchaserRegisterNum:ret.words_result[0].result.purchaser_register_num[0].word,
                PurchaserName:ret.words_result[0].result.purchaser_name[0].word,
                buyCompanyName:ret.words_result[0].result.purchaser_name[0].word||'',
                taxMoney:0,
                invoiceWarehouseInvoiceType:"",
                billingDate:ret.words_result[0].result.start_date[0].word,
                businessType:ret.words_result[0].result.ServiceType[0].word,
                salesCompanyName:ret.words_result[0].result.issued_by[0].word||'',
              }
            }
            if (retData.AmountInFiguers && retData.InvoiceNum) {
              if (
                retData.PurchaserRegisterNum &&
                retData.PurchaserRegisterNum == "91420106MADMODGT5F"
              ) {
                //O转0
                retData.PurchaserRegisterNum = "91420106MADM0DGT5F";
              }
              succCallBack && succCallBack(retData);
            } else {
              failCallBack && failCallBack("票据类型匹配有误,请换一张发票！");
            }
          } else {
            if (!isStop) {
              that.getInfoByReceiptPlus(
                baiduToken,
                url,
                succCallBack,
                failCallBack,
                urlType,
                "roll",
                true,
                invoiceType
              );
            } else {
              failCallBack && failCallBack("不能识别的图片,请换一张发票！");
            }
            return false;
          }
        }
      }
    };
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack && failCallBack("请求接口失败,请稍后再试！");
    };
    if (urlType == "pdf_file") {
      xhr.send(
        "pdf_file=" + encodeURIComponent(url) + "&type=" + (type || "normal")
      );
      // return
      // var formData = new FormData();
      // formData.append("type", type || "normal");
      // formData.append("pdf_file",encodeURIComponent( url));
      // formData.append("verify_parameter",'false');
      // formData.append("probability",'false');
      // formData.append("location",'false');
      // console.log(url);
      // xhr.send(formData);
    } else {
      // xhr.send("url=" + url + "&type=" + (type || "normal"));
      xhr.send(
        "image=" + encodeURIComponent(url) + "&type=" + (type || "normal")
      );
    }
  },

  getFloats(str) {
    // 正则表达式匹配浮点数
    const floatRegex = /[-+]?\d*\.\d+|\d+(\.\d+)?([eE][-+]?\d+)?/g;
    // 匹配字符串中的所有浮点数并将它们转换为数值
    const floats = str.match(floatRegex).map(Number);
    return floats[0];
  },
  getInfoByReceiptCommon(
    baiduToken,
    url,
    succCallBack,
    failCallBack,
    urlType,
    type,
    isStop,
    invoiceType
  ) {
    if (invoiceType == "2"||invoiceType == "3") {
      this.getInfoByReceiptPlus(
        baiduToken,
        url,
        succCallBack,
        failCallBack,
        urlType,
        type,
        isStop,
        invoiceType
      );
    } else {
      this.getInfoByReceipt(
        baiduToken,
        url,
        succCallBack,
        failCallBack,
        urlType,
        type,
        isStop
      );
    }
  },

  //增值税发票识别
  getInfoByReceiptBase64(
    baiduToken,
    base64,
    succCallBack,
    failCallBack,
    urlType,
    type,
    isStop
  ) {
    let that = this;
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open(
      "POST",
      "https://aip.baidubce.com/rest/2.0/ocr/v1/vat_invoice?access_token=" +
        baiduToken,
      true
    );
    //    xhr.responseType="json";
    //   xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          let ret = JSON.parse(xhr.response);
          if (ret.words_result) {
            //   if(!ret.words_result.AmountInFiguers&&ret.words_result.InvoiceNumConfirm){
            //     ret.words_result.AmountInFiguers=parseFloat(ret.words_result.InvoiceNumConfirm.replace("￥","")).toFixed(2)
            //   }
            succCallBack && succCallBack(ret.words_result);
          } else {
            //   failCallBack && failCallBack("不能识别的图片,请换一张发票！")
            if (!isStop) {
              that.getInfoByReceiptBase64(
                baiduToken,
                base64,
                succCallBack,
                failCallBack,
                urlType,
                "roll",
                true
              );
            } else {
              failCallBack && failCallBack("发票识别失败,已保存图片！");
            }
            return false;
          }
        }
      }
    };
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack && failCallBack("网络环境不好,请稍切换网络试试！");
    };
    if (urlType == "pdf_file") {
      var formData = new FormData();
      formData.append("type", type || "normal");
      formData.append("pdf_file", url);
      xhr.send(formData);
    } else {
      xhr.send("url=" + url + "&type=" + (type || "normal"));
    }
    //

    // var xhr = new XMLHttpRequest();

    // var formData = new FormData();
    // formData.append("type", "normal");
    // formData.append("pdf_file", url);
    // xhr.open('POST', 'https://aip.baidubce.com/rest/2.0/ocr/v1/vat_invoice?access_token=24.f792b1e77fa73da9d32a8469958671e4.2592000.1652519224.282335-25920024', true);
    // xhr.onreadystatechange = callback;
    // xhr.send(formData);

    // function callback(){
    //     if (xhr.readyState == 4){
    //         console.log(xhr.response);
    //         alert(JSON.stringify(xhr.response))
    //     }
    // }
  },
  //增值税发票验真
  getInfoByReceiptTrueOrFalse(baiduToken, url, succCallBack, failCallBack) {
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open(
      "POST",
      "https://aip.baidubce.com/rest/2.0/ocr/v1/vat_invoice_verification?access_token=" +
        baiduToken,
      true
    );
    xhr.responseType = "json";
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    //xhr.setRequestHeader('Access-Control-Allow-Headers',' *');
    //xhr.setRequestHeader('Access-Control-Allow-Origin','*');
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          //请求成功了,拿到返回的数据
          //let tempRet=JSON.parse( xhr.responseText)
          if (xhr.response.words_result) {
            succCallBack && succCallBack(xhr.response.words_result);
          } else {
            failCallBack && failCallBack("不能识别的图片,请换一张发票！");
            return false;
          }
        }
      }
    };
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack && failCallBack("网络环境不好,请稍切换网络试试！");
    };
    //xhr.send("invoice_code=1500173130&invoice_num=02806007&invoice_date=20190401&invoice_type=专用发票&check_code=929907897517&total_amount=0.92");
    xhr.send(
      "invoice_code=033002000511&invoice_num=00140981&invoice_date=20200805&invoice_type=elec_normal_invoice&check_code=602585&total_amount=176.99"
    );
  },

  //增值税发票验真(解决跨域)
  Ajax(params) {
    params = params || {};
    params.data = params.data || {};
    var _json = params.jsonp ? jsonp(params) : json(params); // 判断是json还是jsonp
    function json(params) {
      // 普通请求
      params.type = (params.type || "GET").toUpperCase(); // 设置请求默认类型
      var urlData = formatParams(params.data); // 对数据进行格式化
      var xhr = null; // 对xhr进行初始化
      if (window.XMLHttpRequest) {
        xhr = new window.XMLHttpRequest();
      } else {
        xhr = new ActiveXObject("Microsoft.XMLHTTP");
      }
      var headers = params.headers || {};
      if (params.type === "GET") {
        xhr.open(params.type, params.url + "?" + urlData, true);
        setHeaders(xhr, headers);
        xhr.send(null);
      } else {
        xhr.open(params.type, params.url, true);
        setHeaders(xhr, headers);
        xhr.send(JSON.stringify(params.data));
      }
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          var status = xhr.status;
          if (status >= 200 && status < 300) {
            var response = "";
            var type = xhr.getResponseHeader("Content-Type");
            if (type.indexOf("xml") !== -1 && xhr.responseXML) {
              // xml格式
              response = xhr.responseXML;
            } else if (type.indexOf("application/json") !== -1) {
              // JSON格式
              response = JSON.parse(xhr.responseText);
            } else {
              response = xhr.responseText; // 字符串格式
            }
            params.success && params.success(response);
          } else {
            params.error && params.error(status);
          }
        }
      };
    }
    function jsonp(params) {
      var callbackName = params.jsonp; // 回调函数名
      var head = document.getElementsByTagName("head")[0];
      params.data["callback"] = callbackName;
      var data = formatParams(params.data);
      var script = document.createElement("script");
      head.appendChild(script);
      // 创建jsonp函数，成功后自动让success函数调用，在自动删除
      window[callbackName] = function(json) {
        // 设置回调，获取后台数据后才执行
        head.removeChild(script);
        clearTimeout(script.timer);
        window[callbackName] = null;
        params.success && params.success(json);
      };
      script.src = params.url + "&" + data; // 设置src的时候才开始向后台请求数据
      if (params.time) {
        // 限定时间
        script.timer = setTimeout(function() {
          window[callbackName] = null;
          head.removeChild(script);
          params.error &&
            params.error({
              message: "超时"
            });
        }, params.time);
      }
    }
    function formatParams(data) {
      // 使用 encodeURIComponent 对 URI的某部分编码
      var arr = [];
      for (var key in data) {
        arr.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
      }
      // 添加随机数，防止缓存
      arr.push("v=" + random());
      return arr.join("&");
    }
    function random() {
      return Math.floor(Math.random() * 10000 + 500);
    }
    function setHeaders(xhr, headers) {
      for (var key in headers) {
        xhr.setRequestHeader(key, headers[key]);
      }
    }
  },

  checkTokenRefresh() {
    if (!store.state.stateObject.getTokening) {
      store.state.stateObject.getTokening = true;
      api
        .refreshToken()
        .then(res => {
          if (res.data) {
            store.state.stateObject.tokenRefreshTime = new Date();
            let tempUserInfo = store.state.stateObject.userInfo;
            tempUserInfo.token = res.data;
            let obj = {
              userInfo: tempUserInfo,
              getTokening: false
            };
            store.commit("stateFn2", obj);
            utilsObj.saveLocation("userInfo", JSON.stringify(tempUserInfo));
            utilsObj.saveLocation("token", tempUserInfo.token);
            
          }
        })
        .catch(err => {
          let obj = {
            getTokening: false
          };
          store.commit("stateFn2", obj);
        });
    }
  },
  logout(msg) {
    Dialog.confirm({
      title: "温馨提示",
      message: msg + "，需要重新登录?",
      showCancelButton: false
    })
      .then(() => {
        SXApi.call(null, null, "FunctionPlugin", "logout", null);
        localStorage.setItem("thisProjectInfo", "");
        utilsObj.saveLocation("thisProjectInfo", "");
      })
      .catch(() => {
        // on cancel
        store.state.stateObject.alertOut = false;
      });
  },
  //调用
  // changeCallFuncEx: function () {
  //     debugger
  //     commonObj.Ajax({
  //       url: 'https://aip.baidubce.com/rest/2.0/ocr/v1/vat_invoice_verification?access_token='+this.stateObject.baiduToken+"&invoice_code=033002000511&invoice_num=00140981&invoice_date=20200805&invoice_type=elec_normal_invoice&check_code=602585&total_amount=176.99",
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       jsonp: 'getUser',
  //       time: 2000,
  //       success(res) {
  //         debugger
  //           console.log(res);
  //       },
  //       error(status) {
  //           console.log(`some error status = ${status.msg}`);
  //       }
  //   })
  //   },
  //获取文件名称
  getFileName(url, appLocal) {
    let arry1 = url.split("/");
    let str1 = arry1[arry1.length - 1];
    let arry2 = str1.split(".");
    let typeLength = arry2[arry2.length - 1].length; //类型长度不一致
    let retStr = str1.substring(0, str1.length - typeLength - 37);
    try {
      retStr = decodeURIComponent(retStr);
    } catch (error) {
      retStr = "附件";
    }

    if (retStr == "" || appLocal) {
      let splitStr = str1.indexOf("_");
      retStr = str1.substring(splitStr + 1, str1.length);
      return retStr;
    }
    return retStr + "." + arry2[arry2.length - 1];
  },
  fileLoad(url) {
    SXApi.call(function(suc) {}, null, "FunctionPlugin", "download_look_file", {
      url: url,
      isOpen: "0"
    });
  },
  openFile(url) {
    SXApi.call(function(suc) {}, null, "FunctionPlugin", "download_look_file", {
      url: url,
      isOpen: "1"
    });
  },
  //人脸识别
  faceRecognition(baiduToken, base1, base2, succCallBack, failCallBack) {
    let that = this;
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open(
      "POST",
      "https://aip.baidubce.com/rest/2.0/face/v3/match?access_token=" +
        baiduToken,
      true
    );
    xhr.setRequestHeader("Content-Type", "application/json");
    //    xhr.responseType="json";
    //   xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          let ret = JSON.parse(xhr.response);
          if (ret.result) {
            succCallBack && succCallBack(ret.result);
          } else {
            that.hidLoading();
            // if (!isStop) {
            //     that.faceRecognition(baiduToken, url, succCallBack, failCallBack, urlType, "roll", true);
            // } else {
            if (ret.error_code == 223120) {
              failCallBack && failCallBack("图片较为模糊请重拍！");
            } else if (ret.error_code == 222202) {
              failCallBack && failCallBack("图片中没有人脸！");
            } else {
              failCallBack &&
                failCallBack("图片识别不了请重试！" + ret.error_code);
            }
            // }
            return false;
          }
        }
      }
    };
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack && failCallBack("网络环境不好,请稍切换网络试试！");
    };

    let post = [
      {
        image: base1,
        image_type: "BASE64",
        face_type: "LIVE",
        liveness_control: "HIGH"
      },
      {
        image: base2,
        image_type: "BASE64",
        face_type: "LIVE",
        liveness_control: "HIGH"
      }
    ];
    xhr.send(JSON.stringify(post));
  },
  //人脸识别-底图url，拍照base64
  faceRecognition2(baiduToken, url, base2, succCallBack, failCallBack) {
    let that = this;
    let xhr = new XMLHttpRequest();
    xhr.timeout = 6000;
    xhr.open(
      "POST",
      "https://aip.baidubce.com/rest/2.0/face/v3/match?access_token=" +
        baiduToken,
      true
    );
    xhr.setRequestHeader("Content-Type", "application/json");
    //    xhr.responseType="json";
    //   xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded');
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        //请求完成了
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status == 304) {
          let ret = JSON.parse(xhr.response);
          if (ret.result) {
            succCallBack && succCallBack(ret.result);
          } else {
            that.hidLoading();
            // if (!isStop) {
            //     that.faceRecognition(baiduToken, url, succCallBack, failCallBack, urlType, "roll", true);
            // } else {
            if (ret.error_code == 223120) {
              failCallBack && failCallBack("图片较为模糊请重拍！");
            } else if (ret.error_code == 222202) {
              failCallBack && failCallBack("图片中没有人脸！");
            } else {
              failCallBack &&
                failCallBack("图片识别不了请重试！" + ret.error_code);
            }
            // }
            return false;
          }
        }
      }
    };
    xhr.ontimeout = xhr.onerror = err => {
      failCallBack && failCallBack("网络环境不好,请稍切换网络试试！");
    };

    let post = [
      {
        image: url,
        image_type: "URL",
        face_type: "LIVE",
        liveness_control: "HIGH"
      },
      {
        image: base2,
        image_type: "BASE64",
        face_type: "LIVE",
        liveness_control: "HIGH"
      }
    ];
    xhr.send(JSON.stringify(post));
  },

  getTime(dataStr) {
    var date = new Date(dataStr);
    return date.getTime();
  },
  openVoiceInput(succCallBack) {
    let that = this;
    SXApi.call(
      function(suc) {
        if (suc.data.content) {
          succCallBack && succCallBack(suc.data.content);
        }
      },
      function(err) {},
      "FunctionPlugin",
      "openVoiceInput",
      null
    );
  },
  //埋点-EventId:页面名称
  talkingDataFunc(EventId) {
    try {
      if (process.env.TalkingData) {
        TDAPP.onEvent(EventId);
      }
    } catch (error) {}
  },
  toMoney(num) {
    if (num == 0 || num == null) {
      return 0;
    }
    var newNum = num / 10000;
    return newNum.toFixed(2);
  },
  getStallUseArray() {
    return ["未知类别车位", "产权车位", "人防车位", "机械车位", "使用权车位"];
  },
  getStallTypeArray() {
    return [
      "未知类型车位",
      "标准车位",
      "豪华车位",
      "微型车位",
      "子母车位",
      "机械平层",
      "机械二层",
      "机械地坑"
    ];
  },
  formatSeconds(seconds) {
    // if (typeof seconds !== 'number' || isNaN(seconds)) {
    //   console.error('输入的不是有效的数字');
    //   return '';
    // }
    seconds = Number(seconds);
    // 处理负数情况
    seconds = Math.abs(seconds);
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;

    let result = "";
    if (hours > 0) {
      result += `${hours}时`;
    }
    if (minutes > 0) {
      result += `${minutes}分`;
    }
    if (seconds > 0 || (hours === 0 && minutes === 0)) {
      result += `${Math.floor(seconds)}秒`;
    }

    return result;
  },
  getActionMaps() {
    return [
      // { name: "带看活动", val: 2 },
      { name: "定金活动", val: 3 },
      { name: "抵扣券活动", val: 5 },
      { name: "自定义带看活动", val: 6 },
      { name: "拼团活动", val: 999 }
    ];
  },
  getActionMapsAll() {
    return [
      "",
      "报名活动",
      "带看活动",
      "定金活动",
      "每周活动",
      "抵扣券活动",
      "自定义带看活动",
      "直播福袋",
      "开盘活动"
    ];
  },
  getDraftContractStateMap(state) {
      if (state == 0) return "未发起";
      if (state == 1) return "审核中";
      if (state == 2) return "审核通过";
      if (state == 3) return "审核拒绝";
      if (state == 4) return "已撤回";
      return "";
    },
    getDraftContractStateStyle(state) {
    let style = {
        fontSize: "12px",
        color: "#666",
        background: "#f2f2f2",
        padding: "2px 8px",
        borderRadius: "10px",
        marginLeft: "8px",
        flexShrink: "0",
        display: "inline-block"
    };
    if (state == 1) {
        style.color = "#ff8f00";
        style.background = "#fff3e0";
    } else if (state == 2) {
        style.color = "#07c160";
        style.background = "#e6f9ed";
    } else if (state == 3) {
        style.color = "#ee0a24";
        style.background = "#ffecec";
    }
    return style;
},
  formatTimeToDays(timeStr) {
    // 分割时间字符串
    const timeParts = timeStr.split(":");
    if (timeParts.length !== 3) {
      return "无效的时间格式";
    }

    // 解析小时、分钟、秒
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    const seconds = parseInt(timeParts[2], 10);

    // 计算天数和剩余小时数
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;

    // 根据不同情况返回不同格式的时间
    if (days === 0 && remainingHours === 0 && minutes === 0) {
      // 只有秒数
      return `${seconds}秒`;
    } else if (days === 0 && remainingHours === 0) {
      // 只有分秒
      return `${minutes}分${seconds}秒`;
    } else if (days === 0) {
      // 只有时分秒
      return `${remainingHours}时${minutes}分${seconds}秒`;
    } else {
      // 完整格式：天时分秒
      return `${days}天${remainingHours}时${minutes}分${seconds}秒`;
    }
  },
   formatSecondsToHMS(seconds) {
  // 处理输入不是有效数字的情况
  if (typeof seconds !== 'number' || isNaN(seconds)) {
    return '0秒';
  }
  // 处理负数情况
  seconds = Math.abs(seconds);

  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  seconds %= 60;

  const parts = [];
  if (hours > 0) {
    parts.push(`${hours}时`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}分`);
  }
  if (seconds > 0 || (hours === 0 && minutes === 0)) {
    parts.push(`${seconds}秒`);
  }

  return parts.join('');
},
  localAudioSet(callback,value,type) {
    let hisid = this.getCurrentHisId();
        SXApi.call(
            function (suc) { 
                localStorage.setItem("localAudioStute", suc.data.state);
                localStorage.setItem("localAudioType", type);
                callback&&callback(suc);    
            },
            null,
            "FunctionPlugin",
            "openRecord",
            {
              hisId: hisid,
              mapType: value
            }
        );
    },
    /* 
     * 传递权限字段，判断是否有权限
     * @param {Array | string} 
     * @returns {boolean}
     */
    checkAction(action) {
      let actions = store.state.stateObject.userInfo.actions;
      if (!actions) return false;
      if (Array.isArray(action)) {
        return action.some(item => actions.includes(item));
      }
      return actions.includes(action);
    },
    //
    //保存手机本地日志
    saveLocaMessage(value) {
      try {
        SXApi.call(function (suc) {}, null, "FunctionPlugin", "write_log", {
          message: value
        });
      } catch (error) {}
    },
    //是否黑名单
    isBlackList() {
      let userInfo = store.state.stateObject.userInfo;
      let ret = false;
      if(userInfo.staffId=='10ef9cb974f24c82852474239fac8328'){
        ret = true;
      }
      return ret;
    },
};



// WEBPACK FOOTER //
// ./src/commonjs/common.js